import React from 'react';
import { motion } from 'framer-motion';
import '../css/ongoingprojects.css';
import season2 from '../imgs/startupsingam2.jpeg';
import video from '../imgs/startup2.mp4';

export const Ongingprojects1 = () => {
  return (
    <div className="singam-page">
      <motion.section
        className="hero-section"
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <h1 className="gradient-heading">ONGOING SHOW: STARTUP SINGAM SEASON 2</h1>
      </motion.section>

      <motion.section
        className="poster-section"
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.8, delay: 0.2 }}
      >
        <img className="poster-image" src={season2} alt="Startup Singam Season 2 Poster" />
      </motion.section>

      <motion.section
        className="video-section"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1, delay: 0.4 }}
      >
        <video controls className="promo-video" src={video} />
      </motion.section>

      <motion.section
        className="info-section"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, delay: 0.6 }}
      >
        <h2 className="subheading">
          Startup Singam Season 2 is here and this time, it's <span className="highlight">MORE</span> in every way.
        </h2>
        <ul className="metrics">
          <li><strong>₹150 Cr</strong> on the table</li>
          <li><strong>75 Startups</strong></li>
          <li><strong>26 Episodes</strong></li>
          <li><strong>100+ HNIs</strong></li>
          <li><strong>25+ Investors</strong></li>
        </ul>
        <p>Simplify Fundraise. Amplify Success Stories.</p>
        <p>This isn't just a show — <strong>it's your moment.</strong></p>

        <a className="cta-button" href="https://www.startupsingam.com/">Apply Now</a>
      </motion.section>
      <motion.section className="crew-section">
        <h2 className="crew-heading">Meet The Team</h2>

        {/* TOP 4 CARDS */}
        <div className="crew-top">

          <div className="crew-main-card">
            <h4>Director</h4>
            <p>Mohanakrishnan</p>
          </div>

          <div className="crew-main-card">
            <h4>Series Producer</h4>
            <p>Suresh Iyer</p>
          </div>

          <div className="crew-main-card">
            <h4>Founders</h4>
            <p>Hemachandran L</p>
            <p>Balachandar R</p>
          </div>

          <div className="crew-main-card">
            <h4>Chief Mentor</h4>
            <p>Kumar Vembu</p>
          </div>

        </div>

        {/* LARGE DETAIL CARD */}
        <div className="crew-big-card">

          <h4>Core Team</h4>

          <p><strong>Executive Producer:</strong> Ramanarayanan</p>
          <p><strong>Production Controller:</strong> Paramesh</p>
<br/>
<br/>

 <h4>Director Team</h4>
          <p><strong>Creative Directors:</strong> Ramji, Vijay Vivekananda</p>
          <p><strong>Co Director:</strong> Chithra</p>

          <p><strong>Writers:</strong> Clement, Francis</p>

          <p><strong>Associate Directors:</strong> Udhayaprabhu, Parvadhavardhini, Ramya</p>

          <p><strong>Assistant Producer:</strong> Hari Prasath K</p>

          <p><strong>AV Directors:</strong> Praveen, Niresh, Daniel, James</p>

          <p><strong>Post Production:</strong> Thangaraj (Head), Udhaya Prabhu (Producer)</p>
 <p><strong>Sub Editors:</strong> Deepak, Santhosh, Santhosh</p>

        </div>

      </motion.section>
    </div>
  );
};
